import { memo } from 'react';

const RequiredLabel = memo(({ children }: { children: React.ReactNode }) => (
  <span>
    {children}
    <strong
      className="text-danger"
      style={{ fontSize: '17px', float: 'right' }}
    >
      *
    </strong>
  </span>
));

export default RequiredLabel;

export const isValidObjectId = (id: string): boolean => {
  if (!id) return false;
  // Accept MongoDB ObjectIds (24-char hex) or UUIDs
  return /^[0-9a-fA-F]{24}$/.test(id) || /^[0-9a-fA-F-]{32,36}$/.test(id);
};
